import { useCallback } from 'react';
import { useUpdateUserBalance } from 'js/hooks/user';
import { TDynamicBalancesResponse } from 'js/hooks/socket/types';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

export const useHandleBalanceUpdateNotification = () => {
    const updateUserBalance = useUpdateUserBalance();

    return useCallback((response: TDynamicBalancesResponse): void => {
        updateUserBalance(response.data.balances);
        publicEventsAPIService.trigger('userBalanceUpdated', response);
    }, [updateUserBalance]);
};
